export default __webpack_public_path__ + "static/media/emblem2S.2300a961.png";